import React, { createContext, ReactNode, useContext, useState } from 'react';

interface RouterContextType {
  state: Record<string, any>;
  setGlobalAppState: (state: Record<string, any>) => void;
}

const ReactContextRouter = createContext<RouterContextType | undefined>(undefined);

export const RouterProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [state, setGlobalAppState] = useState<Record<string, any>>({});

  return <ReactContextRouter.Provider value={{ state, setGlobalAppState }}>{children}</ReactContextRouter.Provider>;
};

export const useRouter = () => {
  const context = useContext(ReactContextRouter);
  if (!context) {
    throw new Error('useRouter must be used within a RouterProvider');
  }
  return context;
};
